var link_viewer_default = {
  "fontElementMap": "_6m3F6",
  "link": "aL8A4",
  "linkInEditor": "Vi8M9",
  "linkInViewer": "_9-cXI",
  "toolbarUrlContainer": "fWcws",
  "toolbarUrl": "-hhec",
  "toolbarUrlAnchor": "_190sb"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
